import React from 'react';
import {Box, Switch, Typography} from '@mui/material';
import ToggleOnOutlinedIcon from '@mui/icons-material/ToggleOnOutlined';
import {useTranslation} from 'react-i18next';

interface SwitchCardProps {
    label: string;
    on: boolean;
    onChange: (on: boolean) => void;
    /** Inside a row card: the row card's inner surface, like a compact FieldCard. */
    compact?: boolean;
}

/** A layer the admin lets the user switch off (Template.toggles), in the same
 *  card language as a field. Not a checklist item, so no number chip. */
const SwitchCard: React.FC<SwitchCardProps> = ({label, on, onChange, compact}) => {
    const {t} = useTranslation();
    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            border: `1px solid ${compact ? '#ffffff30' : '#ffffff50'}`,
            borderRadius: compact ? '12px' : '14px',
            p: compact ? 1.25 : 1.5,
            mb: compact ? 1 : 1.5,
            backgroundColor: compact ? '#071826' : '#0a1f33',
        }}>
            <ToggleOnOutlinedIcon sx={{color: '#C3F3FD'}}/>
            <Box sx={{flexGrow: 1, minWidth: 0}}>
                <Typography sx={{color: 'white', fontWeight: 600, fontSize: compact ? '0.88rem' : '0.95rem'}} noWrap>
                    {label}
                </Typography>
                <Typography sx={{color: on ? '#C3F3FD' : '#7fa1ba', fontSize: '0.8rem'}} noWrap>
                    {t(on ? 'editor.rows.shown' : 'editor.rows.switchedOff')}
                </Typography>
            </Box>
            <Switch checked={on} onChange={(_, checked) => onChange(checked)} inputProps={{'aria-label': label}}/>
        </Box>
    );
};

export default SwitchCard;
